import { createRoot } from 'react-dom/client'
import ErrorBoundary from './components/ErrorBoundary'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Mount React first; Sentry init is deferred so it never blocks the
// critical-path render. See R2 in docs/BUNDLE-SW-AUDIT-2026-05-16.md.
createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Defer Sentry init to idle time. We accept that the (rare) error in
// the first ~16ms of app boot may not be reported — Sentry's
// installation cost (~90 KB gz JS to parse + integrations to register)
// is not worth blocking the first paint over.
type IdleWindow = typeof window & {
  requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
};
const w = window as IdleWindow;
if (typeof w.requestIdleCallback === 'function') {
  w.requestIdleCallback(() => initSentry(), { timeout: 2000 });
} else {
  setTimeout(initSentry, 0);
}
